import React, { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../store/global';

import TransferHeader from '../components/common/TransferHeader';
import RechargeItem from '../components/common/RechargeItem';
import NormalButton from '../components/common/NormalButton';
import Inputbox from '../components/common/Inputbox';
import TextArea from '../components/common/TextArea';
import EmailIcon from '../components/svg/EmailIcon';
import WhatsappIcon from '../components/svg/WhatsappIcon';

export default function Contact() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const [contactMethod, setContactMethod] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');

  return (
    <div className="relative py-8 flex items-center justify-center">
      <div className="w-153.5 bg-white border border-[#E6EBF7] rounded-[20px] p-6 space-y-6">
        {contactMethod != 'email' && (
          <>
            <TransferHeader
              headerTitle="Ayuda"
              description="Selecciona el método de contacto para recibir asistencia."
              goBack={() => navigate('/')}
            />

            <div className="space-y-2">
              <RechargeItem
                leftIcon={<EmailIcon />}
                title="Por correo electrónico"
                subTitle=""
                onClick={() => setContactMethod('email')}
              />
              <RechargeItem
                leftIcon={<WhatsappIcon />}
                title="Por Whatsapp"
                subTitle=""
                onClick={() => setContactMethod('whatsapp')}
              />
            </div>
          </>
        )}

        {contactMethod == 'email' && (
          <>
            <TransferHeader
              headerTitle="Ayuda"
              description="Selecciona el método de contacto para recibir asistencia."
              goBack={() => setContactMethod('')}
            />

            <div className="space-y-6">
              <Inputbox
                title="Correo electrónico"
                placeholder="ejemplo@mail.com"
                value={email}
                onChange={setEmail}
              />

              <TextArea
                title="Consulta"
                placeholder="Contanos en qué te podemos ayudar..."
                value={description}
                onChange={setDescription}
              />

              <div className="float-right mb-6">
                <NormalButton
                  customClass="bg-[#092F7B] text-white"
                  text="Enviar consulta"
                  onClick={() => console.log('clicked')}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
